import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 15"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "m13 14.367-1.4-1.374 4.6-4.511H0V6.52h16.2l-4.6-4.51L13 .636 20 7.5l-7 6.865Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };